import { pxToRem } from '@/theme/typography';
import shallow from 'zustand/shallow';
import { useDetectAdBlock } from 'adblock-detect-react';
import { useDialog } from '../state';
import { useEffect } from 'react';
export const useAdBlockDetector = () => {
  const adBlockDetected = useDetectAdBlock();
  const setDialog = useDialog(s => s.setDialog, shallow);

  useEffect(() => {
    if (adBlockDetected) {
      setDialog({
        wrapper: true,
        tabletMinHeight: pxToRem(500),
        isAdBlockDialog: true,
      });
    } else {
      setDialog({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adBlockDetected]);

  return {};
};
